export default {
  getExplainInfo: '/activationScore/client/scoreSpecification'
}
